const SITE_URL = "https://www.mauriziobrioschi.com";
const DEFAULT_IMAGE = `${SITE_URL}/cover1.png`;
const DEFAULT_ROBOTS = "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1";

const ensurePath = (path = "/") => {
    if (!path.startsWith("/")) {
        return `/${path}`;
    }
    return path;
};

export const buildPageMeta = ({
    title,
    description,
    keywords,
    path = "/",
    image = DEFAULT_IMAGE,
    robots = DEFAULT_ROBOTS
}) => {
    const normalizedPath = ensurePath(path);
    const url = `${SITE_URL}${normalizedPath}`;
    return {
        canonical: url,
        meta: {
            title,
            name: {
                description,
                keywords,
                author: "Maurizio Brioschi",
                creator: "Maurizio Brioschi",
                publisher: "Maurizio Brioschi",
                robots,
                googlebot: robots,
                bingbot: robots,
                "twitter:card": "summary_large_image",
                "twitter:title": title,
                "twitter:description": description,
                "twitter:image": image,
                "twitter:url": url
            },
            property: {
                "og:type": "website",
                "og:site_name": "Maurizio Brioschi",
                "og:locale": "en_GB",
                "og:title": title,
                "og:description": description,
                "og:url": url,
                "og:image": image
            }
        }
    };
};

export const buildNoIndexMeta = ({ title, description, path = "/" }) =>
    buildPageMeta({
        title,
        description,
        path,
        robots: "noindex,nofollow"
    });
